import * as types from './actionTypes';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import {ORIGINATIONS_APP_BASE_URL, PARTNER_API_BASE_URL} from '../constants/global';

// action that corresponds to a reducer to update state with requestedStips
export function receiveRequestedStips(json) {
  return {type: types.RECEIVE_REQUESTED_STIPS, requestedStips: json};
}

// setup stips url off ORIGINATIONS_APP_BASE_URL with correct routes
export function stipsURL(opportunityId) {
  return `${ORIGINATIONS_APP_BASE_URL()}opportunities/${opportunityId}/stipulations`;
}

// use authenticatedFetch against stipsUrl#index to get all the various stips
// data and dispatch it to receiveRequestedStips
export function fetchRequestedStips(opportunityId) {
  return dispatch => {
    return authenticatedFetch(`${stipsURL(opportunityId)}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(json => dispatch(receiveRequestedStips(json)));
  };
}

export function setFilesToBeUploaded(filesArray) {
  return {type: types.SET_FILES_TO_BE_UPLOADED, files: filesArray};
}

export function setStipFileTag(filePreview, tagValue) {
  return {type: types.SET_STIP_FILE_TAG, data: {filePreview, tagValue}};
}

export function setStipFileDescription(filePreview, description) {
  return {type: types.SET_STIP_FILE_DESCRIPTION, data: {filePreview, description}};
}

export function setStipFileOwner(filePreview, ownerUuid) {
  return {type: types.SET_STIP_FILE_OWNER, data: {filePreview, ownerUuid}};
}

export function setStipFileExpiration(filePreview, expiresOn) {
  return {type: types.SET_STIP_FILE_EXPIRATION, data: {filePreview, expiresOn}};
}

export function receiveSubmissionOwners(owners) {
  return {type: types.RECEIVE_SUBMISSION_OWNERS, owners};
}

export function submissionOwnersURL(submissionUuid) {
  return `${PARTNER_API_BASE_URL()}v1/submissions/${submissionUuid}/owners`;
}

// Underwriting requires a Drivers License attachment to name the owner it
// belongs to. Fetch the owners up front so the tagger can offer a choice when
// there is more than one; a single-owner submission is resolved server-side, so
// no picker is shown for it.
//
// Failures resolve to an empty list rather than rejecting: a missing owner list
// must not block uploading every other stip on the page. The Drivers License
// fields stay hidden, and the API rejects the upload with a clear message if it
// really did need an owner.
export function fetchSubmissionOwners(submissionUuid) {
  return dispatch => {
    return authenticatedFetch(submissionOwnersURL(submissionUuid), {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(response => {
      if (!response.ok) { throw new Error('Failed to fetch submission owners'); }
      return response.json();
    })
    .then(json => dispatch(receiveSubmissionOwners(json.owners || [])))
    .catch(() => dispatch(receiveSubmissionOwners([])));
  };
}
